class WowrioComparisonTable extends HTMLElement {
  #controller = new AbortController();
  #lastTrigger = null;

  connectedCallback() {
    const { signal } = this.#controller;

    this.addEventListener('click', this.#handleClick, { signal });

    const dialog = this.querySelector('[data-wowrio-comparison-dialog]');
    if (dialog instanceof HTMLDialogElement) {
      dialog.addEventListener('cancel', this.#handleCancel, { signal });
      dialog.addEventListener('click', this.#handleDialogBackdropClick, { signal });
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = new AbortController();
  }

  #handleClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const openTrigger = target.closest('[data-wowrio-comparison-open]');
    if (openTrigger instanceof HTMLElement) {
      event.preventDefault();
      this.#lastTrigger = openTrigger;
      this.#openDialog();
      return;
    }

    const closeTrigger = target.closest('[data-wowrio-comparison-close]');
    if (closeTrigger) {
      event.preventDefault();
      this.#closeDialog();
      return;
    }

    const accordionTrigger = target.closest('[data-wowrio-comparison-accordion]');
    if (accordionTrigger instanceof HTMLButtonElement) {
      event.preventDefault();
      this.#toggleAccordion(accordionTrigger);
    }
  };

  #handleCancel = (event) => {
    event.preventDefault();
    this.#closeDialog();
  };

  #handleDialogBackdropClick = (event) => {
    const dialog = event.currentTarget;
    if (dialog instanceof HTMLDialogElement && event.target === dialog) {
      this.#closeDialog();
    }
  };

  #openDialog() {
    const dialog = this.querySelector('[data-wowrio-comparison-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  #closeDialog() {
    const dialog = this.querySelector('[data-wowrio-comparison-dialog]');
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }

    if (this.#lastTrigger instanceof HTMLElement) {
      this.#lastTrigger.focus({ preventScroll: true });
    }
  }

  #toggleAccordion(trigger) {
    const panel = trigger.nextElementSibling;
    if (!(panel instanceof HTMLElement)) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  }
}

if (!customElements.get('wowrio-comparison-table')) {
  customElements.define('wowrio-comparison-table', WowrioComparisonTable);
}
